export default __webpack_public_path__ + "static/media/auteuil5.ac6c4144.jpg";